<template>
    <div class="markdown-panel">
        <!--<div class="el-icon-search"></div>-->
        <div class="fa fa-print" title="Drukuj dokumentację" @click="prepareDocsPrint"></div>
        <div class="fa fa-file-pdf-o" title="Pobierz dokumentację PDF" @click="getPdfFile"></div>
    </div>
</template>

<script>
import Vue from 'vue'
import { apiClass } from '../../classes/api.class'
import { mapState } from 'vuex'

export default {
  name: 'MarkdownPanel',
  computed: {
    ...mapState({
      lang: state => state.sdk.lang,
      device: state => state.sdk.device,
      version: state => state.sdk.version,
      navigation: state => state.sdk.navigation
    })
  },
  methods: {
    prepareDocsPrint () {
      let PrintComponent

      apiClass.getSdkFile(this.version, 'print-', this.device, this.lang, '.html')
        .then(
          response => {
            PrintComponent = Vue.extend({ template: '<div class="container"><div class="content"><div class="inner">' + response + '</div></div></div>' })
            openPrintWindow(this.$t('sdkDocs'))
          },
          error => {
            console.error(error)
          })

      function openPrintWindow (title) {
        const printWindow = window.open('', 'PRINT', 'height=800,width=600')
        printWindow.document.write(`<html><head><link href="/css/print.css" rel="stylesheet"><title>${title}</title></head><body><div id="app"></div></body></html>`)
        printWindow.document.close()
        const appElement = printWindow.document.getElementById('app')
        new PrintComponent().$mount(appElement)
        printWindow.focus()
        checkWindowStylesheets(printWindow)
      }

      function checkWindowStylesheets (window) {
        if (window.document.styleSheets.length < 1) {
          return setTimeout(() => {
            checkWindowStylesheets(window)
          }, 250)
        }
        window.print()
        window.close()
      }
    },
    getPdfFile () {
      window.open(window.location.origin + '/autopay_sdk_mobile/v' + this.version + '/' + this.device + '-' + this.lang + '-' + this.version + '.pdf')
    }
  }
}
</script>
